import React from 'react';
import { useBoolVariation, useInitializationStatus } from '@launchdarkly/react-sdk';

import {
  CHAT_ASSISTANT_FLAG_KEY,
  isLaunchDarklyConfigured,
} from '/packages/shared-components/utils/launchDarkly/constants';
import { ConnectedFloatingChatAssistant, type ConnectedFloatingChatAssistantProps } from './FloatingChatAssistant';

const LaunchDarklyChatAssistantGate = (props: ConnectedFloatingChatAssistantProps) => {
  const { status } = useInitializationStatus();
  const isChatAssistantEnabled = useBoolVariation(CHAT_ASSISTANT_FLAG_KEY, false);

  if (status === 'initializing' || !isChatAssistantEnabled) {
    return null;
  }

  return <ConnectedFloatingChatAssistant {...props} />;
};

export const ChatAssistantGate = (props: ConnectedFloatingChatAssistantProps) => {
  if (!isLaunchDarklyConfigured()) {
    return null;
  }

  return <LaunchDarklyChatAssistantGate {...props} />;
};
